const insuranceProductId = 8848537583869;
const flatRateVariant = 46827359469821;
const declineVariant = 46827371004157;

document.addEventListener("DOMContentLoaded", function () {
  console.log("Cart script loaded");

  function getCart() {
    return fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => cart);
  }

  // Require agreement checkbox before enabling checkout
  const agreeCheckbox = document.getElementById("cart_agree");

  function toggleCheckoutButtons() {
    const checkoutButtons = document.querySelectorAll(
      'button[name="checkout"], .cart__checkout, input[name="checkout"], a[href*="/checkout"]'
    );
    const agreeCheckbox = document.querySelector('#cart_agree');

    checkoutButtons.forEach((btn) => {
      btn.disabled = !agreeCheckbox.checked;
      btn.style.opacity = agreeCheckbox.checked ? "1" : "0.5";
      btn.style.pointerEvents = agreeCheckbox.checked ? "auto" : "none";
    });

  }

  if (agreeCheckbox) {
    // Disable checkout until checkbox checked
    toggleCheckoutButtons();

    agreeCheckbox.addEventListener("change", () => {
      toggleCheckoutButtons();
    });
  }

  function removeInsuranceItems() {
    return getCart()
      .then((cart) => {
        let insuranceItems = cart.items.filter(
          (item) => item.product_id === insuranceProductId
        );
        if (insuranceItems.length > 0) {
          let updates = {};
          insuranceItems.forEach((item) => {
            updates[item.id] = 0; // Set quantity to 0 to remove item
          });

          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates }),
          })
            .then((response) => response.json())
            .then(() => {
              console.log("Insurance items removed from cart");
              // Reload the page to reflect the updated cart
              window.location.reload();
            });
        }
      })
      .catch((error) =>
        console.error("Error removing insurance items:", error)
      );
  }

  function showInsurancePopup() {
    let overlay = document.createElement("div");
    overlay.id = "popupOverlay";
    overlay.style.cssText =
      "position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); z-index: 1000;";
    document.body.appendChild(overlay);

    let popup = document.createElement("div");
    popup.id = "insurancePopup";
    popup.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      max-width: 600px;
      max-height: 90vh;
      overflow-y: auto;
      background: white;
      padding: 20px;
      z-index: 1001;
      border: 2px solid black;
      text-align: center;
      box-sizing: border-box;
    `;

    popup.innerHTML = `
      <p style="font-size: clamp(18px, 4vw, 24px); font-weight: bold; margin-bottom: 15px;">Full Kit now offers InsureShield</p>
      <p style="font-size: clamp(14px, 3vw, 18px); margin-bottom: 20px; line-height: 1.5;">
          With package theft on the rise nationwide, InsureShield Package Protect provides peace of mind that your order is protected from loss, damage, or theft right up until it's in your hands. For only $3 per order, your shipment will be fully insured.
      </p>
      <div style="display: flex; flex-direction: column; gap: 10px; margin-top: 20px;">
          <button id="acceptInsurance" style="padding: 12px 20px; font-size: clamp(14px, 3vw, 18px); cursor: pointer; border-radius: 3px; border: 1px solid #ccc; background-color: #d54e4d; color: white; width: 100%;">
              Checkout with Delivery Insurance
          </button>
          <button id="declineInsurance" style="padding: 12px 20px; font-size: clamp(14px, 3vw, 18px); cursor: pointer; background-color: #888888; color: white; border-radius: 3px; border: none; width: 100%;">
              Decline Delivery Insurance
          </button>
      </div>
  `;

    document.body.appendChild(popup);

    document
      .getElementById("acceptInsurance")
      .addEventListener("click", function () {
        addInsuranceToCart().then(() => {
          // Remove overlay and popup
          document.body.removeChild(overlay);
          document.body.removeChild(popup);
          // Proceed to checkout
          window.location.href = "/checkout";
        });
      });

    document
      .getElementById("declineInsurance")
      .addEventListener("click", function () {
        document.body.removeChild(overlay);
        document.body.removeChild(popup);
        showFinalWarning();
      });
  }

  function showFinalWarning() {
    let overlay = document.createElement("div");
    overlay.id = "warningOverlay";
    overlay.style.cssText =
      "position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); z-index: 1000;";
    document.body.appendChild(overlay);

    let warningPopup = document.createElement("div");
    warningPopup.id = "finalWarningPopup";
    warningPopup.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 90%;
      max-width: 600px;
      max-height: 90vh;
      overflow-y: auto;
      background: white;
      padding: 20px;
      z-index: 1001;
      border: 2px solid black;
      text-align: center;
      box-sizing: border-box;
    `;

    warningPopup.innerHTML = `
      <p style="font-size: clamp(18px, 4vw, 24px); font-weight: bold; margin-bottom: 15px;">PLEASE NOTE:</p>
      <p style="font-size: clamp(14px, 3vw, 18px); margin-bottom: 15px; line-height: 1.5;">Standard carrier insurance only covers your order until they mark it as delivered. For only $3, InsureShield Package Protect will cover your order against loss, damage, and theft, including porch piracy.</p>
      <p style="font-size: clamp(14px, 3vw, 18px); margin-bottom: 20px; line-height: 1.5;">If you decline additional insurance and your package goes missing after delivery, you are responsible for the loss.</p>
      <div style="display: flex; flex-direction: column; gap: 10px; margin-top: 20px;">
          <button id="finalAccept" style="padding: 12px 20px; font-size: clamp(14px, 3vw, 18px); cursor: pointer; border-radius: 3px; border: 1px solid #ccc; background-color: #d54e4d; color: white; width: 100%;">
              Checkout with Delivery Insurance
          </button>
          <button id="finalDecline" style="padding: 12px 20px; font-size: clamp(14px, 3vw, 18px); cursor: pointer; background-color: #888888; color: white; border-radius: 3px; border: none; width: 100%;">
              Decline Delivery Insurance
          </button>
      </div>
  `;
    document.body.appendChild(warningPopup);

    document
      .getElementById("finalAccept")
      .addEventListener("click", function () {
        addInsuranceToCart().then(() => {
          document.body.removeChild(overlay);
          document.body.removeChild(warningPopup);
          // Proceed to checkout
          window.location.href = "/checkout";
        });
      });

    document
      .getElementById("finalDecline")
      .addEventListener("click", function () {
        addDeclineToCart().then(() => {
          document.body.removeChild(overlay);
          document.body.removeChild(warningPopup);
          // Proceed to checkout
          window.location.href = "/checkout";
        });
      });
  }

  function addInsuranceToCart() {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: flatRateVariant, quantity: 1 }),
    }).then(() => console.log("Insurance added"));
  }

  function addDeclineToCart() {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: declineVariant, quantity: 1 }),
    }).then(() => console.log("Insurance declined"));
  }

  // Intercept checkout button clicks
  function interceptCheckout(event) {
    event.preventDefault();
    event.stopPropagation();
    
    getCart().then((cart) => {
      // Check if cart has items and doesn't have insurance
      if (cart.total_price > 0 && !cart.items.some((item) => item.product_id === insuranceProductId)) {
        showInsurancePopup();
      } else {
        // If insurance already exists or cart is empty, proceed to checkout
        window.location.href = "/checkout";
      }
    });
    
    return false;
  }

  // Remove old insurance items immediately on page load
  removeInsuranceItems().then(() => {
    // Set up checkout button interception after a short delay
    setTimeout(() => {
      const checkoutButtons = document.querySelectorAll(
        'button[name="checkout"], .cart__checkout, input[name="checkout"], a[href*="/checkout"]'
      );
      
      checkoutButtons.forEach(button => {
        button.addEventListener('click', interceptCheckout, true);
      });
      
      console.log(`Intercepting ${checkoutButtons.length} checkout buttons`);
    }, 500);
  });
});